import type { ThemeData } from '../models';

export const defaultTheme: ThemeData = {
  freeGiftProduct: {
    default: null,
  },
  collectionBanner: {
    default: {
      src: `https://cdn.shopify.com/s/files/1/1525/9812/files/desktop-sale-banner.jpg?v=1700631286`,
      height: 450,
      width: 2160,
      alt: `Pink background`,
    },
  },
  collectionBannerHideText: {
    default: false,
  },
  legalNotice: {
    default: false,
  },
  homeHeroBanner: {
    default: null,
  },
  homeHero: {
    default: {
      media: {
        mobile: {
          src: 'https://cdn.shopify.com/videos/c/o/v/8bd3f8d9f60c449f954b757644a2fc70.mp4',
          height: 272,
          width: 414,
        },
        desktop: {
          src: 'https://cdn.shopify.com/videos/c/o/v/402c059fb5e94fdd9b099e96f8b2d802.mp4',
          height: 640,
          width: 760,
        },
        alt: 'Exfoliating tooth wipes',
        to: '/products/exfoliating-tooth-wipes/',
      },
      content: {
        title: 'Wipe away stains with Tooth Wipes',
        description: `Engineered with hydroxyapatite and xylitol to lift the day's build-up off your teeth.`,
        button: {
          text: 'Shop now',
          to: '/products/exfoliating-tooth-wipes/',
          width: 'full-width',
          size: 'md',
        },
      },
    },
  },
  homeSaleBanner: {
    default: {
      content: {
        title: 'Shop our bundles',
        description: 'Shop now',
        to: '/collections/bundles',
      },
      backgroundColor: 'rgb(var(--brand-pink))',
    },
  },
  homeShowcaseMode: {
    default: 'media',
  },
  homeShowcaseOptions: {
    default: {
      mobile: {
        contentAlign: 'left',
        contentPadding: '2rem',
        contentPosition: 'top-left',
        textColor: 'dark',
        titleFontSize: '2rem',
        descriptionFontSize: '1rem',
        descriptionColor: '#030303',
        aspectRatio: '131 / 235',
        maxContentWidth: '27rem',
        buttonMaxWidth: '20rem',
      },
      desktop: {
        contentAlign: 'left',
        contentPadding: '0 0 0 2.5rem',
        contentPosition: 'top-left',
        textColor: 'dark',
        buttonMaxWidth: '10rem',
        titleFontSize: '2.25rem',
        descriptionFontSize: '1rem',
        descriptionColor: '#030303',
        maxContentWidth: '27rem',
      },
    },
  },
  homeShowcaseContent: {
    default: {
      content: {
        title: 'Your everyday whitening routine, sorted.',
        description: 'An easy way to stay consistent with<br>whitening at home.',
        afterContent: {
          button: {
            to: '/products/affordable-whitening-set',
            text: 'Shop now',
            variant: 'primary',
          },
        },
      },
      background: {
        media: {
          mobile: {
            src: 'https://cdn.shopify.com/s/files/1/0916/4078/files/Page_Feature_-_Affordable_Whitening_Set_AWS_-_D.png?v=1779764471',
            height: 1024,
            width: 570,
          },
          desktop: {
            src: 'https://cdn.shopify.com/s/files/1/0916/4078/files/Page_Feature_-_Affordable_Whitening_Set_AWS_-_D.png?v=1779764471',
            height: 668,
            width: 1365,
          },
          alt: 'Flavoured toothpaste bundle 3 pack',
        },
      },
    },
  },
  homeShowcaseMedia: {
    default: {
      mobile: {
        src: 'https://cdn.shopify.com/s/files/1/2502/5300/files/Page_Feature_-_MPB_-_M.png?v=1790053607',
        height: 1024,
        width: 570,
      },
      desktop: {
        src: 'https://cdn.shopify.com/s/files/1/2502/5300/files/Page_Feature_-_MPB_-_D.png?v=1790053607',
        height: 668,
        width: 1365,
      },
    },
    ca: {
      mobile: {
        src: 'https://cdn.shopify.com/s/files/1/2502/5300/files/Page_Feature_-_V34_text_-_CA_-_M.png?v=1778537641',
        height: 1024,
        width: 570,
      },
      desktop: {
        src: 'https://cdn.shopify.com/s/files/1/2502/5300/files/Page_Feature_-_V34_text_-_CA_-_D.png?v=1778537642',
        height: 668,
        width: 1365,
      },
    },
  },
  homeShowcaseMediaLink: {
    default: {
      to: `/products/whitening-protocol-bundle`,
    },
    ca: {
      to: `/products/v34-whitening-strips`,
    },
  },
  navImageBlocks: {
    default: {
      imageBlocks: [
        {
          title: 'iD Stain Whitening Mouthwash',
          link: '/products/id-stain-mouthwash/',
          details: {
            src: 'https://cdn.shopify.com/s/files/1/2502/5300/files/Nav_-_Starter_Bundle_V2-_M_cdbf4791-c1b1-4542-adf2-ceb3fbcdae9c.png?v=1767658631',
            alt: 'iD Stain Whitening Mouthwash',
            height: 240,
            width: 366,
          },
        },
        {
          title: 'Exfoliating Tooth Wipes',
          link: '/products/exfoliating-tooth-wipes',
          details: {
            src: 'https://cdn.shopify.com/s/files/1/0916/4078/files/Nav_-_Tooth_Wipes.png?v=1779944897',
            alt: 'Tooth Wipes',
            height: 240,
            width: 366,
          },
        },
      ],
    },
    ca: {
      imageBlocks: [
        {
          title: 'Shop Electric Toothbrush',
          link: '/products/electric-toothbrush/',
          details: {
            src: 'https://cdn.shopify.com/s/files/1/0916/4078/files/Nav_-_Electric_Toothbrush.jpg?v=1706071329',
            alt: 'Electric Toothbrush in Pink, Purple and Green',
            height: 240,
            width: 366,
          },
        },
        {
          title: 'Tooth Armour',
          link: '/products/tooth-armour',
          details: {
            src: 'https://cdn.shopify.com/s/files/1/2502/5300/files/Nav_-_Tooth_Armour.png?v=1774928763',
            alt: 'Tooth Armour',
            height: 240,
            width: 366,
          },
        },
      ],
    },
  },
  marqueeData: {
    default: {
      text: `NEW Tooth Wipes, available NOW`,
      to: `/products/exfoliating-tooth-wipes`,
    },
    ca: {
      text: `New Tooth Armour Toothpaste Serum. Order NOW`,
      to: `/products/tooth-armour`,
    },
  },
  delayedShippingMessages: {
    default: [],
  },
  globalProductPill: {
    default: null,
  },
  globalProductCardBadge: {
    default: null,
  },
  globalProductImageBadge: {
    default: null,
  },
};
